export const largeDownloadsKeys = {
  phoneAnalytics: 'phone-analytics',
  smsAnalytics: 'sms-analytics',
};
